import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect'

import AsyncForm from './components/async-form';
import Gallery from './components/gallery';
import Modal from './components/modal';
import PartnersBar from './components/partners-bar';
import Timeline from './components/timeline';

Alpine.plugin(intersect)
window.Alpine = Alpine;

Alpine.data('asyncForm', AsyncForm);
Alpine.data('gallery', Gallery);
Alpine.data('timeline', Timeline);
Alpine.data('modal', Modal);
Alpine.data('partnersBar', PartnersBar);

Alpine.start();
